
import { useParams } from "react-router-dom";
import logo from "../../Assets/green.png";
import classes from "./Aff.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getAffiliationById } from "../../Store/AffReducer/affSlice";
import { useEffect } from "react";
import cartIcon from "../../Assets/cart.svg";
import shareIcon from "../../Assets/share.png";


export default function AffHome() {

  const { id } = useParams();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.aff.affiliation);
  const products = useSelector((state) => state.aff.products);

  useEffect(() => {
    dispatch(getAffiliationById(id));
  }, [id, dispatch]);

  const handleShare = async (product) => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: product.name,
          text: `Check out ${product.name}`,
          url: product.productUrl,
        });
      } else {
        await navigator.clipboard.writeText(product.productUrl);
        alert("Product link copied!");
      }
    } catch (error) {
      console.error("Unable to share:", error);
    }
  };


  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <img
          src={logo}
          alt="Logo"
          className={classes.logo}
        />
        <p className={classes.description}>Pharmacist-led research delivering trusted supplement recommendations based on science, quality ingredients, reputable brands, and real customer experiences.
        </p>
      </div>

      <div className={classes.productHead}>
        <h2>{data?.name || "Best Supplements"}</h2>
      </div>

      <div className={classes.products}>
        {products.map((product, index) => (
          <article
            key={product.id}
            className={classes.product}
          >
            <div className={classes.imageContainer}>
              {product.id === 1 && (
                <div
                  className={classes.topPicked}
                  style={{ background: "#f94144" }}
                >
                  #{product.id}
                </div>
              )}

              {product.id === 2 && (
                <div
                  className={classes.topPicked}
                  style={{ background: "#f8961e" }}
                >
                  #{product.id}
                </div>
              )}

              {product.id === 3 && (
                <div
                  className={classes.topPicked}
                  style={{ background: "#43aa8b" }}
                >
                  #{product.id}
                </div>
              )}

              {product.id > 3 && (
                <div
                  className={classes.topPicked}
                  style={{ background: "#4C4646" }}
                >
                  #{product.id}
                </div>
              )}

              <img
                src={product.imageUrl}
                alt={product.name}
                className={classes.productImage}
              />
            </div>

            <div className={classes.productContent}>


              <h3 className={classes.productName}>{product.name}</h3>

              <div className={classes.ratingRow}>
                <span className={classes.ratingScore}>{product.score}</span>
                <span className={classes.ratingLabel}>Origin :</span>
                <p className={classes.productMadeIn}>{product.origin}</p>
              </div>

              {/* <p className={classes.productMadeIn}>{product.madeIn}</p> */}

              <p className={classes.productReason}>{product.description}</p>

              <div className={classes.buttonContainer}>
                <a
                  href={product.productUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.buyButton}
                >
                  <img
                    src={cartIcon}
                    alt=""
                    className={classes.buttonIcon}
                  />
                  Get Now
                </a>

                <button
                  type="button"
                  className={classes.shareButton}
                  onClick={() => handleShare(product)}
                  aria-label={`Share ${product.name}`}
                >
                  <img
                    src={shareIcon}
                    alt=""
                    className={classes.shareIcon}
                  />
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>

    </div>
  );
}
